import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgNotify = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M2.04 13h10.92q.489 0 .764-.227a.75.75 0 0 0 .276-.607q0-.344-.2-.668a3.7 3.7 0 0 0-.503-.634l-.592-.62a1.6 1.6 0 0 1-.358-.613 5 5 0 0 1-.186-.806q-.063-.427-.09-.827c-.014-.881-.11-1.928-.29-2.616q-.26-1.034-.82-1.737-.557-.702-1.473-1.033a2.4 2.4 0 0 0-.71-1.144Q8.26 1 7.497 1q-.758 0-1.275.468a2.4 2.4 0 0 0-.71 1.144q-.916.33-1.48 1.033-.56.703-.82 1.737c-.175.688-.27 1.735-.283 2.616q-.027.4-.09.827a4.4 4.4 0 0 1-.192.806q-.124.38-.352.613-.296.31-.6.62a4 4 0 0 0-.495.634q-.2.324-.2.668 0 .38.276.607.275.227.764.227m5.46 2.625q.586 0 1.047-.255.462-.255.737-.668s.35-.38.383-.702H5.444c.027.322.083.426.272.702a2.13 2.13 0 0 0 1.784.923"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgNotify);
export default ForwardRef;
